module.exports = __webpack_public_path__ + "static/media/green_line_get_start.947fbeb7.svg";